import { makeStyles } from '@material-ui/core';
import themeStyle from 'styles/theme';
import colors from './colors';

const contentStyles = makeStyles(theme => ({
  label: {
    ...themeStyle.typography.smMedium,
    color: colors.gray[700]
  },
  input: {
    minWidth: 80,
    padding: '10px 14px',
    marginTop: 6,
    borderRadius: 8,
    background: colors.base.white,
    border: `1px solid ${colors.gray[300]}`,
    boxShadow: '0px 1px 2px 0px rgba(16, 24, 40, 0.05)',
    '&:hover': {
      boxShadow:
        '0px 1px 2px 0px rgba(16, 24, 40, 0.05), 0px 0px 0px 4px rgba(158, 119, 237, 0.24)'
    },
    '&:focus': {
      borderRadius: '8px !important'
    },
    '&::before': {
      content: undefined
    }
  },
  menu: {
    ...themeStyle.typography.smMedium,
    maxHeight: 245,
    color: colors.gray[900],
    marginTop: theme.spacing(0.25),
    border: `1px solid ${colors.gray[200]}`,
    borderRadius: theme.spacing(1),
    background: colors.base.white,
    boxShadow:
      ' 0px 12px 16px -4px rgba(16, 24, 40, 0.08), 0px 4px 6px -2px rgba(16, 24, 40, 0.03);'
  },
  menuItem: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1)
  }
}));

export default contentStyles;
